import ownerDocument from '@mui/utils/ownerDocument';
export default ownerDocument;


//////////////////
// WEBPACK FOOTER
// ../@mui/material/utils/ownerDocument.js
// module id = 165
// module chunks = 22